module.exports = __webpack_public_path__ + "img/hr-heated-straight-vertical-2.013b2695.png";